import type { DataGridColumn, GroupedColumnOverride } from './data-grid.types';

/** Grouped-leaf header for point-asset `fromMeasure` columns. */
export const POINT_ASSET_FROM_MEASURE_HEADER: string = 'At';

/**
 * Returns true when the schema geometry type represents a point asset (At measure).
 */
export function isPointSchemaGeometryType(geometryType: string | null | undefined): boolean {
  if (geometryType === null || geometryType === undefined || geometryType.trim() === '') {
    return false;
  }

  const normalized: string = geometryType.trim().toUpperCase();
  // Strip PostGIS measure suffix so `POINT M` matches develop map geometry mapping.
  const withoutMeasure: string = normalized.replace(/\s+M$/, '');
  return withoutMeasure === 'POINT' || withoutMeasure === 'MULTI_POINT' || withoutMeasure === 'MULTIPOINT';
}

/**
 * Applies per-element-type header overrides and hides columns for grouped leaf
 * tables. Returns shallow-cloned column definitions so shared column metadata
 * is never mutated.
 */
export function applyGroupedColumnOverrides(
  columns: ReadonlyArray<DataGridColumn>,
  elementType: string,
  overrides: ReadonlyMap<string, ReadonlyMap<string, GroupedColumnOverride>>
): Array<DataGridColumn> {
  if (overrides.size === 0) {
    return [...columns];
  }

  const result: Array<DataGridColumn> = new Array<DataGridColumn>();

  for (const column of columns) {
    const typeOverrides: ReadonlyMap<string, GroupedColumnOverride> | undefined = overrides.get(column.field);
    const override: GroupedColumnOverride | undefined = typeOverrides?.get(elementType);

    if (override?.hidden) {
      continue;
    }

    if (override?.header !== undefined && override.header !== column.header) {
      result.push({ ...column, header: override.header });
      continue;
    }

    result.push(column);
  }

  return result;
}
